import { render, staticRenderFns } from "./ProductVariantLoader.vue?vue&type=template&id=8c27f73a"
import script from "./ProductVariantLoader.vue?vue&type=script&lang=js"
export * from "./ProductVariantLoader.vue?vue&type=script&lang=js"
import style0 from "./ProductVariantLoader.vue?vue&type=style&index=0&id=8c27f73a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports